import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getRegulationPlanWorkFinanceAttributions: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION]
				.GET_REGULATION_PLAN_WORK_FINANCE_ATTRIBUTIONS,
	},

	getRegulationPlanWorkFinanceAttribution: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION]
				.GET_REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION,
	},

	createRegulationPlanWorkFinanceAttribution: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION]
				.CREATE_REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION,
	},

	patchRegulationPlanWorkFinanceAttribution: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION]
				.PATCH_REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION,
	},

	putRegulationPlanWorkFinanceAttribution: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION]
				.PUT_REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION,
	},

	deleteRegulationPlanWorkFinanceAttribution: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION]
				.DELETE_REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION,
	},
}
